// Catálogo canônico dos 12 signos usado pelo card de Compatibilidade.
// (Mesmos dados que já existem duplicados em PublicHoroscopePage.tsx/HoroscopePage.tsx —
// não refatorei essas páginas pra não mexer em código já em produção, ver plano da sessão.)

export interface ZodiacSign {
  name: string;
  slug: string;
  emoji: string;
  dates: string;
  element: 'Fogo' | 'Terra' | 'Ar' | 'Água';
  ruler: string;
  /** Nome do arquivo em public/signos/ — nota: "sagitario" tem um typo real no asset. */
  image: string;
}

export const ZODIAC_SIGNS: ZodiacSign[] = [
  { name: 'Áries',       slug: 'aries',       emoji: '♈', dates: '21/03 – 19/04', element: 'Fogo',  ruler: 'Marte',     image: 'aries.png' },
  { name: 'Touro',       slug: 'touro',       emoji: '♉', dates: '20/04 – 20/05', element: 'Terra', ruler: 'Vênus',     image: 'touro.png' },
  { name: 'Gêmeos',      slug: 'gemeos',      emoji: '♊', dates: '21/05 – 20/06', element: 'Ar',    ruler: 'Mercúrio',  image: 'gemeos.png' },
  { name: 'Câncer',      slug: 'cancer',      emoji: '♋', dates: '21/06 – 22/07', element: 'Água',  ruler: 'Lua',       image: 'cancer.png' },
  { name: 'Leão',        slug: 'leao',        emoji: '♌', dates: '23/07 – 22/08', element: 'Fogo',  ruler: 'Sol',       image: 'leao.png' },
  { name: 'Virgem',      slug: 'virgem',      emoji: '♍', dates: '23/08 – 22/09', element: 'Terra', ruler: 'Mercúrio',  image: 'virgem.png' },
  { name: 'Libra',       slug: 'libra',       emoji: '♎', dates: '23/09 – 22/10', element: 'Ar',    ruler: 'Vênus',     image: 'libra.png' },
  { name: 'Escorpião',   slug: 'escorpiao',   emoji: '♏', dates: '23/10 – 21/11', element: 'Água',  ruler: 'Plutão',    image: 'escorpiao.png' },
  { name: 'Sagitário',   slug: 'sagitario',   emoji: '♐', dates: '22/11 – 21/12', element: 'Fogo',  ruler: 'Júpiter',   image: 'sargitario.png' },
  { name: 'Capricórnio', slug: 'capricornio', emoji: '♑', dates: '22/12 – 19/01', element: 'Terra', ruler: 'Saturno',   image: 'capricornio.png' },
  { name: 'Aquário',     slug: 'aquario',     emoji: '♒', dates: '20/01 – 18/02', element: 'Ar',    ruler: 'Urano',     image: 'aquario.png' },
  { name: 'Peixes',      slug: 'peixes',      emoji: '♓', dates: '19/02 – 20/03', element: 'Água',  ruler: 'Netuno',    image: 'peixes.png' },
];

export const ELEMENT_GRADIENT: Record<ZodiacSign['element'], string> = {
  Fogo:  'linear-gradient(135deg, #f97316, #dc2626)',
  Terra: 'linear-gradient(135deg, #22c55e, #15803d)',
  Ar:    'linear-gradient(135deg, #38bdf8, #2563eb)',
  Água:  'linear-gradient(135deg, #818cf8, #6d28d9)',
};

export const ELEMENT_BORDER: Record<ZodiacSign['element'], string> = {
  Fogo: 'rgba(249,115,22,0.4)',
  Terra: 'rgba(34,197,94,0.4)',
  Ar: 'rgba(56,189,248,0.4)',
  Água: 'rgba(129,140,248,0.4)',
};

export function getSignBySlug(slug?: string): ZodiacSign | undefined {
  return ZODIAC_SIGNS.find(s => s.slug === slug);
}

export function signImageUrl(sign: ZodiacSign): string {
  return `${process.env.PUBLIC_URL || ''}/signos/${sign.image}`;
}
